import { useApplicationContext } from '~/shared/context/use-application-context';

import { getProfileTasksAvailability, type ProfileTasksAvailability } from '../api/profile-task-transport-adapter';

export type ProfileTaskSummariesInput = Parameters<typeof getProfileTasksAvailability>[0];

export type StructuredProfileTasksAvailability = { readonly status: 'disabled' } | ProfileTasksAvailability;

export const useProfileTasksAvailability = (
    summaries: ProfileTaskSummariesInput,
): StructuredProfileTasksAvailability => {
    const { applicationState } = useApplicationContext();

    if (!applicationState.featureFlagService.isFeatureFlagEnabled('structured-profile-tasks')) {
        return { status: 'disabled' };
    }

    return getProfileTasksAvailability(summaries);
};
